import request from '../../request'
import {participants} from '../../endpoints'

export default class participantsApi {
  static async haveAllStudentEmails(sid, mid) {
    return request({
      url: participants.haveAllStudentEmails(sid, mid),
      method: 'GET',
    })
  }
  static async getSchoolsByMatId(id) {
    return request({
      url: participants.getSchoolsByMatId(id),
      method: 'GET',
    })
  }
  static async getStudentParent(id) {
    return request({
      url: participants.getStudentParent(),
      method: 'POST',
      data: id,
    })
  }
  static async getStaff(id) {
    return request({
      url: participants.getStaff(),
      method: 'POST',
      data: id,
    })
  }
  static async getStaffByFilter(filters) {
    return request({
      url: participants.getStaffByFilter(),
      method: 'POST',
      data: filters,
    })
  }
  static async getStudentByFilter(filters) {
    return request({
      url: participants.getStudentByFilter(),
      method: 'POST',
      data: JSON.stringify(filters),
    })
  }

  static async getParentByFilter(filters) {
    return request({
      url: participants.getParentByFilter(),
      method: 'POST',
      data: JSON.stringify(filters),
    })
  }
  static async getParentByFilter(filters) {
    return request({
      url: participants.getParentByFilter(),
      method: 'POST',
      data: JSON.stringify(filters),
    })
  }
  static async checkPasscode(passcode) {
    return request({
      url: participants.checkPasscode(),
      method: 'POST',
      data: JSON.stringify(passcode),
    })
  }

  static async qrCodeVerify(passcode) {
    return request({
      url: participants.qrCodeVerify(),
      method: 'POST',
      data: JSON.stringify(passcode),
    })
  }
  static async getParticipantFilters(
    schoolId,
    matId,
    needStaffFilter,
    needStudentFilter,
    needParentFilter
  ) {
    return request({
      url: participants.getParticipantFilters(
        schoolId,
        matId,
        needStaffFilter,
        needStudentFilter,
        needParentFilter
      ),
      method: 'GET',
    })
  }

  static async getStaffStudentParentCount(filters) {
    return request({
      url: participants.getStaffStudentParentCount(),
      method: 'POST',
      data: JSON.stringify(filters),
    })
  }
}
